// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d76a9bcf","806":"cebcd77b"}[chunkId] + ".chunk.js";
};